import { useParams, Link } from "react-router-dom";
import { useGetOneBlogQuery } from "./blogApiSlice";
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Dodaj stilove za ReactQuill
import { selectCurrentToken } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";

const BlogDetails = () => {
  const { id } = useParams();
  const { isKlijent, isAdmin } = useAuth();
  const token = useSelector(selectCurrentToken);
  const [history, setHistory] = useState();

  // const [postImage, setPostImage] = useState({ myFile: "" });
  const [blog, setblog] = useState();
  // console.log("id", id);

  //Fetchujemo history
  const requestBlogHistory = async (dataBlog) => {
    const headers = new Headers();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`); // Dodajemo Authorization token ako postoji
    }
    headers.set("Content-Type", "application/json"); // Postavljamo Content-Type na JSON

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/blogHistory`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(dataBlog),
        }
      );

      if (!response.ok) {
        throw new Error(`Error uploading blog history: ${response.statusText}`);
      }

      const blogHistory = await response.json();
      setHistory(blogHistory);

      // console.log("History => ", blogHistory);

      // setPostImage(dataBlog);
    } catch (error) {
      console.error("Error uploading the file:", error);
    }
  };

  const {
    isSuccess: isSuccessGetBlog,
    isError: isErrorGetBlog,
    error: errorBlogError,
    data: getBlogData,
  } = useGetOneBlogQuery(id);

  useEffect(() => {
    if (isSuccessGetBlog) {
      // alert(dataGetBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      const blogData = {
        id: id,
        tip: "", //Jer pretrzujemo sve a ulogovani klijent moze da vidi sve blogove
      };
      requestBlogHistory(blogData);
      setblog(getBlogData);
    }

    if (isErrorGetBlog) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorBlogError?.data?.message);
    }
  }, [isSuccessGetBlog, isErrorGetBlog, errorBlogError, getBlogData]);

  // useEffect(() => {
  //   console.log("blog => ", blog);
  // }, [blog]);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const readableDate = date.toLocaleDateString("sr-RS", {
      year: "numeric", // godina
      month: "numeric", // mesec
      day: "numeric", // dan
    });

    return readableDate;
  }

  const tooltipStyle = {
    position: "relative",
    display: "inline-block",
    cursor: "pointer",
  };

  const tooltipTextStyle = {
    position: "absolute",
    bottom: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "8px",
    backgroundColor: "#333",
    color: "white",
    borderRadius: "4px",
    fontSize: "12px",
    whiteSpace: "nowrap",
    opacity: 0,
    visibility: "hidden",
    transition: "opacity 0.3s ease, visibility 0.3s ease",
    zIndex: 10,
  };

  const tooltipVisibleStyle = {
    ...tooltipTextStyle,
    opacity: 1,
    visibility: "visible",
  };

  return (
    <>
      <div className="blog-details max-w-6xl mx-auto p-8 bg-green-50 rounded-xl shadow-2xl">
        {blog && (
          <article className="space-y-8">
            {/* Title */}
            <h2 className="text-4xl md:text-5xl font-extrabold text-green-800">
              {blog.title}
            </h2>

            {/* Image */}
            <img
              src={blog.slika}
              alt="Neka slika ovde"
              className="w-full h-96 object-cover rounded-xl shadow-xl"
            />

            {/* Information Section (Tags, Author, Date) */}
            <div className="flex flex-col md:flex-row items-start md:items-center text-base text-green-600 space-y-4 md:space-y-0 md:space-x-8">
              {/* Tags */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">🥦</span>
                <span className="text-lg font-semibold text-green-800">
                  Tagovi:
                </span>
                <div className="flex flex-wrap gap-2">
                  {Array.isArray(blog.tags) ? (
                    blog.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300"
                      >
                        {tag}
                      </span>
                    ))
                  ) : (
                    <span className="text-red-600">
                      Tagovi nisu u pravilnom formatu.
                    </span>
                  )}
                </div>
              </p>

              {/* Author */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">👨‍🍳</span>
                <span className="text-lg font-semibold text-green-800">
                  Autor:
                </span>
                <span className="text-green-700">{blog.author}</span>
              </p>

              {/* Date */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">⏰</span>
                <span className="text-lg font-semibold text-green-800">
                  Datum:
                </span>
                <span className="text-green-700">
                  {formatDateToReadable(blog.date)}
                </span>
              </p>
            </div>

            {/* Blog Content */}
            <div
              className="text-xl text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: blog.body
                  .replace(
                    /<ul>/g,
                    '<ul style="list-style-type: disc; margin-left: 1.5rem; margin-bottom: 1rem;">'
                  )
                  .replace(
                    /<ol>/g,
                    '<ol style="list-style-type: decimal; margin-left: 1.5rem; margin-bottom: 1rem;">'
                  )
                  .replace(/<li>/g, '<li style="margin-bottom: 0.5rem;">'),
              }}
            ></div>
          </article>
        )}
      </div>

      <br />

      {/* History */}
      {history && (
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-4">
          {history.previous && (
            <div className="w-full md:w-64">
              <h4 className="text-xl mb-2 md:mb-0">Prethodni blog: </h4>
              <div
                className="bg-white rounded-lg shadow-2xl overflow-hidden w-full"
                key={history.previous._id}
              >
                <Link
                  to={
                    history.previous?._id
                      ? `/dash/blogs/${history.previous._id}`
                      : "#"
                  }
                  className="block"
                >
                  <img
                    src={history.previous.slika}
                    alt="Placeholder Image"
                    className="w-full h-32 object-cover"
                  />
                  <div className="p-3">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold text-gray-900 mb-0">
                        {history.previous.title}
                      </h2>
                    </div>

                    <div className="flex flex-wrap space-x-2">
                      {Array.isArray(history.previous.tags) ? (
                        <>
                          {history.previous.tags
                            .slice(0, 3)
                            .map((tag, index) => (
                              <span
                                key={index}
                                className="inline-block px-2 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
                              >
                                {tag}
                              </span>
                            ))}
                          {history.previous.tags.length > 3 && (
                            <span
                              className="inline-block px-2 bg-green-200 text-green-800 rounded-full text-sm font-medium"
                              title={history.previous.tags.join(", ")}
                            >
                              ...
                            </span>
                          )}
                        </>
                      ) : (
                        <span className="text-red-600">
                          Tagovi nisu u pravilnom formatu.
                        </span>
                      )}
                    </div>

                    <p className="text-xs text-gray-600 mt-1">
                      Autor: {history.previous.author}
                    </p>
                    <p className="text-xs text-gray-600">
                      Datum: {formatDateToReadable(history.previous.date)}.
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          )}

          {history.next && (
            <div className="w-full md:w-64">
              <h4 className="text-xl mb-2 md:mb-0">Sledeći blog: </h4>
              <div
                className="bg-white rounded-lg shadow-2xl overflow-hidden w-full"
                key={history.next._id}
              >
                <Link
                  to={
                    history.next?._id ? `/dash/blogs/${history.next._id}` : "#"
                  }
                  className="block"
                >
                  <img
                    src={history.next.slika}
                    alt="Placeholder Image"
                    className="w-full h-32 object-cover"
                  />
                  <div className="p-3">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold text-gray-900 mb-0">
                        {history.next.title}
                      </h2>
                    </div>

                    <div className="flex flex-wrap space-x-2">
                      {Array.isArray(history.next.tags) ? (
                        <>
                          {history.next.tags.slice(0, 3).map((tag, index) => (
                            <span
                              key={index}
                              className="inline-block px-2 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
                            >
                              {tag}
                            </span>
                          ))}
                          {history.next.tags.length > 3 && (
                            <span
                              className="inline-block px-2 bg-green-200 text-green-800 rounded-full text-sm font-medium"
                              title={history.next.tags.join(", ")}
                            >
                              ...
                            </span>
                          )}
                        </>
                      ) : (
                        <span className="text-red-600">
                          Tagovi nisu u pravilnom formatu.
                        </span>
                      )}
                    </div>

                    <p className="text-xs text-gray-600 mt-1">
                      Autor: {history.next.author}
                    </p>
                    <p className="text-xs text-gray-600">
                      Datum: {formatDateToReadable(history.next.date)}.
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
      )}
      {/* History end */}

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default BlogDetails;

// <div
//   className="bg-white rounded-lg shadow-md overflow-hidden"
//   key={blog.id}
// >
//   <Link to={`${blog.id}`} className="block">
//     <img
//       src={blog.slika}
//       alt="Placeholder Image"
//       className="w-full h-48 object-cover"
//     />
//     <div className="p-4">
//       <div className="flex items-center justify-between">
//         <h2 className="text-xl font-semibold text-gray-900">
//           {blog.title}
//         </h2>
//         <div className="flex flex-wrap space-x-2">
//           {Array.isArray(blog.tags) ? (
//             blog.tags.map((tag, index) => (
//               <span
//                 key={index}
//                 className="inline-block px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
//               >
//                 {tag}
//               </span>
//             ))
//           ) : (
//             <span className="text-red-600">
//               Tagovi nisu u pravilnom formatu.
//             </span>
//           )}
//         </div>
//       </div>
//       <p className="text-sm text-gray-600 mt-2">
//         Autor: {blog.author}
//       </p>
//       <p className="text-sm text-gray-600">
//         Datum: {formatDateToReadable(blog.date)}
//       </p>
//     </div>
//   </Link>
// </div>
